<template>
  <!-- <template v-if="
    (item.title) && (item.title == 'Monitoring') && (roles.includes('SECRETARY')||roles.includes('RECORD')||roles.includes('PACD')||roles.includes('RECORDS STAFF')||roles.includes('DIRECTOR')
              ||roles.includes('CAO')
              ||roles.includes('CEPS')
              ||roles.includes('SEPS')
            )
    ">
      <v-list-item
        :href="href"
        :rel="href && href !== '#' ? 'noopener' : undefined"
        :target="href && href !== '#' ? '_blank' : undefined"
        :to="item.to"
        :active-class="``"
      >
      
        <v-list-item-icon v-if="item.icon">
          <v-icon v-text="item.icon" />
        </v-list-item-icon>
        

        <v-list-item-content v-if="item.title">
          <v-list-item-title v-text="item.title" />
        </v-list-item-content>
      </v-list-item>
  </template>
  <template v-else> -->
    <v-list-item
      :href="href"
      :rel="href && href !== '#' ? 'noopener' : undefined"
      :target="href && href !== '#' ? '_blank' : undefined"
      :to="item.to"
      :active-class="``"
    >
    
      <v-list-item-icon v-if="item.icon">
        <v-icon v-text="item.icon" />
      </v-list-item-icon>
      

      <v-list-item-content v-if="item.title">
        <v-list-item-title v-text="item.title" />
      </v-list-item-content>
    </v-list-item>
  <!-- </template> -->

</template>

<script>
  import Themeable from 'vuetify/lib/mixins/themeable'

  export default {
    name: 'BaseItem',

    mixins: [Themeable],

    props: {
      item: {
        type: Object,
        default: () => ({
           href: undefined,
          icon: undefined,
          title: undefined,
          to: undefined,
        }),
      },
      text: {
        type: Boolean,
        default: false,
      },
    },

    computed: {
      href () {
        return this.item.href || (!this.item.to ? '#' : undefined)
      },

      user_type(){
        return this.$store.getters.getUser.user_type;
      },

      roles(){
        let roles = [];
        if(this.$store.getters.getUserRoles.length){
          this.$store.getters.getUserRoles.forEach(role => {
            roles.push(role.name);
          });
        }

        return roles;
      },
    },
  }
</script>
